import Signature from '@/febos/global/pdf/components/Signature';
import UserSignature from '@/febos/global/pdf/components/UserSignature';
import OfficeSignature from '@/febos/global/pdf/components/OfficeSignature';
import DraggableSignature from '@/febos/global/pdf/components/DraggableSignature';
import DraggableUserSignature from '@/febos/global/pdf/components/DraggableUserSignature';
import DraggableOfficeSignature from '@/febos/global/pdf/components/DraggableOfficeSignature';
import PersonSignature from '@/febos/global/pdf/components/PersonSignature';

export const SIGNATURE_TYPES = {
  Signature,
  UserSignature,
  OfficeSignature,
  DraggableSignature,
  DraggableUserSignature,
  DraggableOfficeSignature,
  PersonSignature
};
